module.exports = "/static/media/idea-icon-white.0a3649d1.png";